import { Injectable } from "@angular/core";
@Injectable()
export class PrintTemplateUtil {
    
    readonly BARCODE_TOKEN: string = 'BARCODE';
    readonly PROJECT_TOKEN: string = 'PROJECT';
    readonly SAMPLE_NAME_TOKEN: string = 'SAMPLENAME';
    readonly SHORTCODE_TOKEN: string = 'SHORTCODE';
    readonly LIBRARY_ID_TOKEN: string = 'LIBRARYID';
    readonly LIBRARY_TYPE_TOKEN: string = 'LIBRARYTYPE'
    
    doesTemplateHaveToken(templateFormat: string, token: string) : boolean {
        return (templateFormat.includes(token));
    }
    
    replaceToken(templateFormat: string, token: string, tokenValue: string) : string {
        let actualTokenVal = tokenValue ? tokenValue : '';
        let re = new RegExp(token, 'gi');
        return templateFormat.replace(re, actualTokenVal);
    }

    substituteTokensForEQC(sampleBarcode: string, projectName: string, sampleName: string, sampleShortCode: string, formatString: string, indexOfSample: number): any {
        formatString = this.replaceToken(formatString, '#' + this.BARCODE_TOKEN + '_' + (indexOfSample+1) + '#', sampleBarcode);
        formatString = this.replaceToken(formatString, '#' + this.PROJECT_TOKEN + '_' + (indexOfSample+1) + '#', projectName);
        formatString = this.replaceToken(formatString, '#' + this.SAMPLE_NAME_TOKEN + '_' + (indexOfSample+1) + '#', sampleName);
        formatString = this.replaceToken(formatString, '#' + this.SHORTCODE_TOKEN + '_' + (indexOfSample+1) + '#', sampleShortCode);
        return formatString
    }
}